import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function subScheduleReducer() {
    return combineReducers({
        SubSchedule_ListSubForPO: createItemReducer("SubSchedule", "Vacancy.ListSubCalForNewPO", false),
        SubSchedule_ListSubForPOParams: createItemReducerParams("SubSchedule", "Vacancy.ListSubCalForNewPO"),
        SubSchedule_MonthList: createItemReducer("SubSchedule", "Vacancy.ListCalMonthForNewPO", false),
        SubSchedule_YearList: createItemReducer("SubSchedule", "Vacancy.ListCalYearForNewPO", false)
    });
}